import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Store } from '@ngrx/store';
import { AuthActions } from '../redux/auth.actions';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  providers: [AuthService],
  standalone: false,
})
export class LogoutComponent implements OnInit {
  private readonly _store = inject(Store);

  ngOnInit() {
    this.logout();
  }

  logout() {
    // Dispatch the logout action to trigger the effect chain
    this._store.dispatch(AuthActions.logoutRequested());
  }
}
